import { render, staticRenderFns } from "./Toogle.vue?vue&type=template&id=80ff283a&scoped=true&lang=pug&"
import script from "./Toogle.vue?vue&type=script&lang=js&"
export * from "./Toogle.vue?vue&type=script&lang=js&"
import style0 from "./Toogle.vue?vue&type=style&index=0&id=80ff283a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ff283a",
  null
  
)

export default component.exports